$wj([96],{

/***/ 3867:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var React = __webpack_require__(3);
var Constants = __webpack_require__(3201);
var Button_1 = __webpack_require__(62);
var createSharingMessageActionText_1 = __webpack_require__(5803);
var Spinner_1 = __webpack_require__(670);
var getSharingMessageAction_1 = __webpack_require__(3866);
var acceptInvite_1 = __webpack_require__(5804);
var showCalendar_1 = __webpack_require__(5809);
var owa_sharing_strings_1 = __webpack_require__(3868);
var mobx_react_1 = __webpack_require__(11);
var styles = __webpack_require__(5810);
var SharingAcceptButton = /** @class */ (function (_super) {
    tslib_1.__extends(SharingAcceptButton, _super);
    function SharingAcceptButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onAcceptButtonClicked = function (evt) {
            _this.setState({ isLoading: true });
            acceptInvite_1.default(_this.props.item.ItemId).then(function (success) {
                _this.setState({ isLoading: false, successfulAccept: success });
            });
        };
        _this.onViewCalendarButtonClicked = function (evt) {
            var newWindow = window.open();
            showCalendar_1.default(newWindow);
        };
        _this.state = { isLoading: false, successfulAccept: false };
        return _this;
    }
    SharingAcceptButton.prototype.render = function () {
        var item = this.props.item;
        var sharingMessageAction = getSharingMessageAction_1.default(item);
        return this.renderActionButton(sharingMessageAction);
    };
    SharingAcceptButton.prototype.renderActionButton = function (sharingMessageAction) {
        if (!sharingMessageAction) {
            return null;
        }
        if (this.state.isLoading) {
            return (React.createElement("div", null,
                React.createElement(Spinner_1.Spinner, { className: styles.spinner, size: Spinner_1.SpinnerSize.small }),
                React.createElement("span", null, owa_sharing_strings_1.default.addingCalendarLoadingText)));
        }
        var primary = sharingMessageAction.Importance === Constants.PRIMARY_IMPORTANCE;
        if (this.state.successfulAccept) {
            var text = createSharingMessageActionText_1.default(Constants.VIEW_CALENDAR);
            return primary ? (React.createElement(Button_1.PrimaryButton, { text: text, onClick: this.onViewCalendarButtonClicked })) : (React.createElement(Button_1.DefaultButton, { text: text, onClick: this.onViewCalendarButtonClicked }));
        }
        else {
            var action = this.state.successfulAccept
                ? Constants.VIEW_CALENDAR
                : sharingMessageAction.Action;
            var text = createSharingMessageActionText_1.default(action);
            var primary_1 = sharingMessageAction.Importance === Constants.PRIMARY_IMPORTANCE;
            return primary_1 ? (React.createElement(Button_1.PrimaryButton, { text: text, onClick: this.onAcceptButtonClicked })) : (React.createElement(Button_1.DefaultButton, { text: text, onClick: this.onAcceptButtonClicked }));
        }
    };
    SharingAcceptButton = tslib_1.__decorate([
        mobx_react_1.observer
    ], SharingAcceptButton);
    return SharingAcceptButton;
}(React.Component));
exports.default = SharingAcceptButton;
//# sourceMappingURL=SharingAcceptButton.js.map

/***/ }),

/***/ 3868:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var index_1 = __webpack_require__(20);
var keys = ['acceptAndViewCalendarAcceptButtonText', 'addThisCalendarAcceptButtonText', 'viewCalendarAcceptButtonText', 'acceptAcceptButtonText', 'addingCalendarLoadingText'];
var stringModule = index_1.registerStringPackage('owa-sharing-strings', null, keys);
var exportedObject = {
    stringsModule: stringModule,
};
keys.forEach(function (key) {
    Object.defineProperty(exportedObject, key, { get: function () { return stringModule.strings.get(key); } });
});
exports.default = exportedObject;


/***/ }),

/***/ 5801:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var addInteractiveElementsForReadingPane_1 = __webpack_require__(5802);
exports.addInteractiveElementsForReadingPane = addInteractiveElementsForReadingPane_1.default;
var SharingAcceptButton_1 = __webpack_require__(3867);
exports.SharingAcceptButton = SharingAcceptButton_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 5802:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(3);
var ReactDOM = __webpack_require__(71);
var SharingAcceptButton_1 = __webpack_require__(3867);
function addInteractiveElementsForReadingPane(element, item) {
    var button = React.createElement(SharingAcceptButton_1.default, { item: item });
    ReactDOM.render(button, element, null /* callback */);
    element.className = ''; // overwrite the server's OLK-hidden class
}
exports.default = addInteractiveElementsForReadingPane;
//# sourceMappingURL=addInteractiveElementsForReadingPane.js.map

/***/ }),

/***/ 5803:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Constants = __webpack_require__(3201);
var owa_sharing_strings_1 = __webpack_require__(3868);
function createSharingMessageActionText(action) {
    switch (action) {
        case Constants.ACCEPT_AND_VIEW_CALENDAR:
            // In React, accepting sharing message is broken into two actions, an "Accept" and then a
            // "View Calendar". So the "Accept and view calendar" button no longer makes sense, so we'll default to
            // just "Accept" instead.
            return owa_sharing_strings_1.default.acceptAcceptButtonText;
        case Constants.ADD_THIS_CALENDAR:
            return owa_sharing_strings_1.default.addThisCalendarAcceptButtonText;
        case Constants.VIEW_CALENDAR:
            return owa_sharing_strings_1.default.viewCalendarAcceptButtonText;
        default:
            /*CalendarSharingAction.Accept is the old default value*/
            return owa_sharing_strings_1.default.acceptAcceptButtonText;
    }
}
exports.default = createSharingMessageActionText;
//# sourceMappingURL=createSharingMessageActionText.js.map

/***/ }),

/***/ 5804:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var acceptSharedCalendarInvite_1 = __webpack_require__(5805);
var selectNewCalendar_1 = __webpack_require__(5808);
var acceptInvite = legacy_1.action('acceptInvite')(function acceptInvite(sharingInviteItemId) {
    return acceptSharedCalendarInvite_1.default(sharingInviteItemId).then(function (response) {
        if (response.ResponseClass == 'Success' && response.NewCalendarEntryId) {
            // select the new calendar
            selectNewCalendar_1.default(response.NewCalendarEntryId.Id);
        }
        return new Promise(function (resolve) {
            resolve(response.ResponseClass == 'Success');
        });
    });
});
exports.default = acceptInvite;
//# sourceMappingURL=acceptInvite.js.map

/***/ }),

/***/ 5805:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var acceptSharedCalendarInviteOperation_1 = __webpack_require__(5806);
var ServiceRequestUtils_1 = __webpack_require__(31);
function acceptSharedCalendarInvite(messageId) {
    return acceptSharedCalendarInviteOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Body: {
            MessageId: messageId,
        },
    }).then(function (response) {
        return response.Body;
    });
}
exports.default = acceptSharedCalendarInvite;
//# sourceMappingURL=acceptSharedCalendarInvite.js.map

/***/ }),

/***/ 5806:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = __webpack_require__(27);
var acceptSharedCalendarInviteJsonRequest_1 = __webpack_require__(5807);
function acceptSharedCalendarInviteOperation(req, options) {
    if (req !== undefined && !req["__type"]) {
        req = acceptSharedCalendarInviteJsonRequest_1.default(req);
    }
    return ServiceRequest_1.makeServiceRequest("AcceptSharedCalendarInvite", req, options);
}
exports.default = acceptSharedCalendarInviteOperation;


/***/ }),

/***/ 5807:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
function acceptSharedCalendarInviteJsonRequest(data) {
    var result = tslib_1.__assign({ __type: 'AcceptSharedCalendarInviteJsonRequest:#Exchange' }, data);
    return result;
}
exports.default = acceptSharedCalendarInviteJsonRequest;


/***/ }),

/***/ 5808:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var userConfigurationDictionaryEntry_1 = __webpack_require__(116);
var userConfigurationDictionaryObject_1 = __webpack_require__(117);
var updateUserConfiguration_1 = __webpack_require__(153);
var getUserConfiguration_1 = __webpack_require__(9);
function selectNewCalendar(newSelectedCalendarId) {
    var selectedCalendarsViewState = getUserConfiguration_1.default().ViewStateConfiguration
        .SelectedCalendarsDesktop;
    if (selectedCalendarsViewState &&
        selectedCalendarsViewState.indexOf(newSelectedCalendarId) < 0) {
        selectedCalendarsViewState.push(newSelectedCalendarId);
    }
    return updateUserConfiguration_1.default('OWA.ViewStateConfiguration', [
        userConfigurationDictionaryEntry_1.default({
            DictionaryKey: userConfigurationDictionaryObject_1.default({
                Type: 'String',
                Value: ['SelectedCalendarsDesktop'],
            }),
            DictionaryValue: userConfigurationDictionaryObject_1.default({
                Type: 'StringArray',
                Value: selectedCalendarsViewState,
            }),
        }),
    ]).then(function (response) {
        var responseItem = response.Body.ResponseMessages.Items[0];
        if (responseItem.ResponseClass == 'Success') {
            return Promise.resolve();
        }
        else {
            return Promise.reject('updateUserConfiguration failed: ' + responseItem.ResponseClass);
        }
    });
}
exports.default = selectNewCalendar;
//# sourceMappingURL=selectNewCalendar.js.map

/***/ }),

/***/ 5809:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = __webpack_require__(1);
var owa_controls_feature_flags_1 = __webpack_require__(33);
var owa_url_1 = __webpack_require__(216);
var hostLocation_1 = __webpack_require__(73);
var getUserConfiguration_1 = __webpack_require__(9);
var showCalendar = legacy_1.action('showCalendar')(function showCalendar(newWindow) {
    var userOptions = getUserConfiguration_1.default().UserOptions;
    // switch to calendar module
    var calendarUrl = owa_controls_feature_flags_1.isControlFeatureEnabled('cal-react') ||
        (userOptions &&
            userOptions.ReactOptinSettings &&
            userOptions.ReactOptinSettings.CalendarEnabled)
        ? hostLocation_1.getHostLocation()
            .href.replace(hostLocation_1.getHostLocation().hash, '')
            .replace(hostLocation_1.getHostLocation().pathname, owa_url_1.getCalendarPath())
        : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/calendar' });
    newWindow.open(calendarUrl, '_self');
    return Promise.resolve();
});
exports.default = showCalendar;
//# sourceMappingURL=showCalendar.js.map

/***/ }),

/***/ 5810:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5811);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5811:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "._23wDhqTzTGlfWmDaMuO3Pr{display:inline-block}html[dir=ltr] ._23wDhqTzTGlfWmDaMuO3Pr{padding-right:10px}html[dir=rtl] ._23wDhqTzTGlfWmDaMuO3Pr{padding-left:10px}", ""]);

// exports
exports.locals = {
	"spinner": "_23wDhqTzTGlfWmDaMuO3Pr"
};

/***/ })

});


// WEBPACK FOOTER //
// owa.SharingAccept.js